import AutoComplete from 'bee-autocomplete'
export default AutoComplete
